module.exports = __webpack_public_path__ + "811db2102063ae55e7b69d981376dc2f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resources/logocore.png
// module id = 268
// module chunks = 0